import { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LogoIcon from '../../components/icons/Logo';
import Service from '../../utils/service';
import { UserContext } from '../../store/UserProvider';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../defs/routes';
import ReloadIcon from '../../components/icons/Reload';

const AccountWaiting = () => {
  const {t} = useTranslation(['common', 'collection']);

  const navigate = useNavigate();

  const userInfo = useContext(UserContext);

  const [showRefresh, setShowRefresh] = useState(false);

  const service = useRef(null);

  const getUser = () => {
    return userInfo.loadUser().then((user) => {
      if (user.accounts?.length > 0) {
        navigate(ROUTES.INDEX, { replace: true });
      }
    }).catch(() => {});
  };

  const handleReloadPage = () => {
    window.location.reload();
  };

  useEffect(() => {
    service.current = new Service(() => {
      setShowRefresh(true);
      getUser();
    }, 5000);

    service.current.start(5000);
    return () => {
      service.current.stop();
    };
  }, []);

  return (
    <div className="trip-app">
      <div className="splash-screen">
        <div className="logo">
          <div className="logo-content">
            <LogoIcon />
          </div>
          <h1 className="title">
              Travel Cloud<br />
              Персонал
          </h1>
          <br/>
          <p className="detail">{t('account:accounts.account_waiting')}</p>
          {showRefresh && (
            <ReloadIcon className='app-reload-button' onClick={handleReloadPage}/>
          )}
        </div>
      </div>
    </div>
  )
}

export default AccountWaiting;